export default "__VITE_ASSET__7c2f9c7a__"